import React, { FC, PropsWithChildren } from "react"
import { useParams } from "react-router-dom"
import { Button, Grid, Typography } from "@mui/material"
import {
  HasSidebarLayout,
  DataLoad,
  EntityHeader,
  SectionInfo,
  PropsInjector,
  SectionSensorInfo,
  SectionRapidRHInfo,
  OuterLink,
  SectionDataLoggerInfo,
} from "src/components"
import { useSectionRequest } from "src/hooks/api"
import { ProjectSection } from "src/api"
import { config } from "src/config"

interface SectionShowContentProps {
  section?: ProjectSection;
}

const SectionShowContent: FC<SectionShowContentProps> = ({
  section = null,
}) => {
  if (!section) return null

  const { name, projectId, id } = section
  const link = `${config.webAppHost}/#/projects/${projectId}/sections/${id}`

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <EntityHeader
          title={name}
          actionBlockOnTheRight={<OuterLink
            to={link}
            style={{ textDecoration: "none" }}
          >
            <Button variant="contained">Open in web app</Button>
          </OuterLink>}
        />
      </Grid>
      <Grid item container spacing={4} xs={12}>
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Section Information
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <SectionInfo section={section} />
          </Grid>
        </Grid>
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              CLīMIT Sensors
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <SectionSensorInfo projectSectionsSenors={section.projectSectionsSensors || []} />
          </Grid>
        </Grid>
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              RapidRH Sensors
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <SectionRapidRHInfo rapidRHProbes={section.wagnerProbes || []} />
          </Grid>
        </Grid>
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              DataPUCK Sensors
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <SectionDataLoggerInfo projectSectionsDataLoggers={section.projectSectionsDataLoggers || []} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

const SectionDataLoader: FC<PropsWithChildren<{ sectionId: number }>> = ({
  sectionId,
  children,
}) => {
  const { isInitialLoading, isError, data } = useSectionRequest({
    id: sectionId,
  })
  document.title = `CLīMIT Admin Panel - Project section ${data?.name || ''}`

  const props = {
    section: data || null,
  }

  return (
    <DataLoad isLoading={isInitialLoading} isError={isError}>
      <PropsInjector props={props}>{children}</PropsInjector>
    </DataLoad>
  )
}

const SectionShow: FC = () => {
  const params = useParams()
  const { id } = params as { id: string }

  return (
    <HasSidebarLayout>
      <SectionDataLoader sectionId={parseInt(id, 10)}>
        <SectionShowContent />
      </SectionDataLoader>
    </HasSidebarLayout>
  )
}

export default SectionShow
